<script setup>
import { ref, watch } from 'vue'

import LanguageSelector from '@/components/shared/LanguageSelector.vue'
import TimeZoneSelector from '@/components/shared/TimeZoneSelector.vue'

const props = defineProps({
  userData: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['save'])

const selectedTimezone = ref(props.userData.default_timezone)

const loading = ref(false)

watch(
  () => props.userData.default_timezone,
  (val) => {
    selectedTimezone.value = val
  }
)

const updateUserSettings = () => {
  loading.value = true

  emit('save', {
    default_timezone: selectedTimezone.value,
  })

  setTimeout(() => { loading.value = false }, 500)
}
</script>

<template>
  <q-card>
    <q-card-section>
      <div class="text-h6">
        {{ $t('user.preferences') }}
      </div>

      <div class="column q-gutter-sm">
        <div>
          <div class="text-caption text-grey-8">
            {{ $t('common.language') }}
          </div>
          <language-selector />
        </div>

        <div>
          <div class="text-caption text-grey-8">
            {{ $t('common.timezone') }}
          </div>
          <time-zone-selector v-model="selectedTimezone" />
        </div>
      </div>
    </q-card-section>

    <q-card-actions>
      <q-btn
        :label="$t('common.save')"
        color="primary"
        unelevated
        class="full-width"
        size="md"
        :loading="loading"
        @click="updateUserSettings"
      />
    </q-card-actions>
  </q-card>
</template>

